<template>
  <a-modal :visible="visible"
           @cancel="$emit('cancel')"
           :destroyOnClose="true"
           :width="1000"
           :confirmLoading="modalLoading"
           :maskClosable="false" title="添加子单位" @ok="onSave" style="text-align: center">
    <a-card>
      <a-form-model
          ref="form"
          :model="itemUnitData"
          :rules="rules"
          class="custom pick-100 form-input"
      >
        <a-row :gutter="80">
          <a-col :span="24">
            <a-form-model-item label="单位名称" prop="unitItems">
              <a-textarea v-model.trim="itemUnitData.unitItems"
                          placeholder="导入格式说明：
1. 简化格式：使用分号“；”（不区分全角和半角）来分隔多个单位。
   样例：腾讯；网易；阿里巴巴；
2. 带统一信用代码的格式：使用逗号“，”（不区分全角和半角）来分隔单位名称和统一社会信用代码，使用分号“；”来分隔多个单位。
   样例：腾讯，123456；网易，54321；阿里巴巴；
"
                          :auto-size="{ minRows: 20, maxRows: 60 }"/>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </a-card>
  </a-modal>
</template>

<script>
import { AddUnitItem } from './api/UnitRequest'

const rules = {
  unitItems: [{ required: true, message: '请输入单位', trigger: 'change' }],
}
export default {
  name: 'AddItemUnitModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },

  },
  components: {},
  data () {
    return {
      rules,
      modalLoading: false,
      itemUnitData: {
        unitItems: '',
        unitId: this.$route.query.unitId,
      }
    }
  },
  created () {
  },
  methods: {
    reset () {
      this.itemUnitData = {
        unitItems: '',
        unitId: this.$route.query.unitId,
      }
    },
    onSave () {
      const that = this
      this.$refs.form.validate(async valid => {
        if (!valid) {
          return
        }
        const data = { ...that.itemUnitData }
        that.modalLoading = true
        let res = await AddUnitItem(data)
        that.modalLoading = false
        if (200 !== res.code) {
          that.$message.error('操作失败！！！')
          return
        }
        that.$message.success('操作成功！！！')
        that.$emit('success')
        that.reset()
      })

    },
  }
}
</script>

<style scoped>

</style>
